import React, { useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter,
} from "@/components/ui/dialog";
import { KeyRound, Loader2 } from "lucide-react";
import { toast } from "sonner";

const EMPTY = { current: "", next: "", confirm: "" };

export const ChangePasswordDialog = () => {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF((s) => ({ ...s, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (f.next !== f.confirm) { toast.error("كلمتا المرور الجديدتان غير متطابقتين"); return; }
    setBusy(true);
    try {
      const { data } = await api.post("/auth/change-password", { current_password: f.current, new_password: f.next });
      localStorage.setItem("token", data.token);
      toast.success("تم تغيير كلمة المرور، وأُلغيت الجلسات على الأجهزة الأخرى");
      setF(EMPTY);
      setOpen(false);
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    setBusy(false);
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="outline" className="rounded-full gap-2" data-testid="change-password-btn"><KeyRound className="w-4 h-4" /> تغيير كلمة المرور</Button>
      </DialogTrigger>
      <DialogContent dir="rtl" data-testid="change-password-dialog">
        <DialogHeader><DialogTitle>تغيير كلمة المرور</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-1.5"><Label>كلمة المرور الحالية</Label>
            <Input type="password" value={f.current} onChange={set("current")} required autoComplete="current-password" data-testid="current-password-input" /></div>
          <div className="space-y-1.5"><Label>كلمة المرور الجديدة</Label>
            <Input type="password" value={f.next} onChange={set("next")} required minLength={10} autoComplete="new-password" data-testid="new-password-input" />
            <p className="text-xs text-muted-foreground">10 أحرف على الأقل، وتحتوي حروفاً وأرقاماً</p></div>
          <div className="space-y-1.5"><Label>تأكيد كلمة المرور الجديدة</Label>
            <Input type="password" value={f.confirm} onChange={set("confirm")} required autoComplete="new-password" data-testid="confirm-password-input" /></div>
          <DialogFooter>
            <Button type="submit" disabled={busy} className="rounded-xl gap-2 w-full" data-testid="change-password-submit">
              {busy && <Loader2 className="w-4 h-4 animate-spin" />} حفظ كلمة المرور
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
